var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.074,
    height: 55.259,
    viewBox: "0 0 69.074 55.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop",
    "data-name": "Icon awesome-laptop",
    d: "M67.347,44.9H41.179a3.4,3.4,0,0,1-3.534,3.454H31.083A3.665,3.665,0,0,1,27.546,44.9H1.727A1.732,1.732,0,0,0,0,46.625v1.727a6.928,6.928,0,0,0,6.907,6.907H62.166a6.928,6.928,0,0,0,6.907-6.907V46.625A1.732,1.732,0,0,0,67.347,44.9ZM62.166,5.181A5.2,5.2,0,0,0,56.986,0h-44.9A5.2,5.2,0,0,0,6.907,5.181V41.444H62.166ZM55.259,34.537H13.815V6.907H55.259Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.acd27e24600b7e18193d55aa1cfbb240.svg";
export { ForwardRef as ReactComponent };